<template>
  <div class="flex md12">
    <span>
      <va-button-group class="flex md12">
        <div class="flex md2">
          <va-button color="info" @click="createConsent"
            >Create Consent</va-button
          >
        </div>
        <div class="md2">
          <va-button color="info" @click="findConsent">Find Consent</va-button>
        </div>
      </va-button-group>
      <search-modal
        class="mb-2"
        modalSize="large"
        @closeModal="filterModal = false"
        :filterConsentsModal="filterModal"
      >
      </search-modal>
    </span>
  </div>
</template>

<script>
import searchModal from "./SearchModal.vue";
import searchTemplate from "../../../app/SearchTemplate.vue"

export default {
  data() {
    return {
      filterModal: false
    };
  },
  methods: {
    createConsent() {
      this.$router.push({ name: "createConsent" });
    },
    findConsent() {
      this.filterModal = true;

      this.$store.dispatch("fetchForms");
    }
  },
  components: {
    searchModal,
  },
  created() {
    this.$store.dispatch("clearForms");
    this.$store.dispatch("clearConsents");
  }
};
</script>
